import FormattedMessage from 'I18n/components/FormattedMessage';
import { Popover, PopoverHeader, PopoverCloseButton, PopoverBody, PopoverFooter } from 'foundations-components/transitional/components/Popover';
import { Button } from 'foundations-components/transitional/components/Button';
import { ReviewContextProvider, useReviewContext } from './context/ReviewContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ReviewPopover({
  bodyContent,
  children,
  customValidationErrors,
  defaultReview,
  headerContent,
  onChange,
  onClose,
  onSubmit,
  popoverProps,
  submitButtonText,
  validationSchema
}) {
  return /*#__PURE__*/_jsx(ReviewContextProvider, {
    customValidationErrors: customValidationErrors,
    defaultReview: defaultReview,
    onChange: onChange,
    validationSchema: validationSchema,
    children: /*#__PURE__*/_jsx(Popover, Object.assign({}, popoverProps, {
      content: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsxs(PopoverHeader, {
          children: [headerContent, /*#__PURE__*/_jsx(PopoverCloseButton, {
            popoverUse: "default",
            onClick: onClose
          })]
        }), /*#__PURE__*/_jsx(PopoverBody, {
          children: bodyContent
        }), /*#__PURE__*/_jsx(PopoverFooter, {
          marginBlockStart: "200",
          children: /*#__PURE__*/_jsx(SubmitButton, {
            onSubmit: onSubmit,
            submitButtonText: submitButtonText
          })
        })]
      }),
      children: children
    }))
  });
}
function SubmitButton({
  onSubmit,
  submitButtonText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "trellisEcosystem.reviews.submit"
  })
}) {
  const {
    review,
    customValidationErrors,
    validationErrors
  } = useReviewContext();
  return /*#__PURE__*/_jsx(Button, {
    use: "primary",
    disabled: validationErrors.length > 0 || customValidationErrors.length > 0,
    onClick: () => onSubmit(review),
    children: submitButtonText
  });
}